import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { format } from 'date-fns';
import './MyModal.css'
function MyModal({ elements }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const showTime = format(new Date(), 'MMddyyyyHis');

  return (
    <div>
      <Button variant="primary" onClick={handleShow}>
        View
      </Button>

      <Modal show={show} onHide={handleClose} className='modal-lg'>
        <Modal.Header className='justify-content-between'>
          <Modal.Title>{elements.businessName}</Modal.Title>
          <Button variant="default" onClick={handleClose}>
            <i className='la la-close'></i>
          </Button>

        </Modal.Header>
        <Modal.Body>
          <table className="table">
            <tbody>
              <tr>
                <th>Image</th>
                <td> <img
                  height={150}
                  className="garage__image"
                  src={`${elements.picture ? `${process.env.REACT_APP_UPLOAD_URL + elements.picture}?time=${showTime}` : `${process.env.REACT_APP_UPLOAD_URL + 'images/images.png'}`}`}
                  alt='imagesURL'
                  style={{ transform: `rotate(${elements.pictureA ? elements.pictureA : 0}deg)` }}
                />
                </td>
              </tr>
              <tr>
                <th>Business Name</th>
                <td>{elements.businessName}</td>
              </tr>
              <tr>
                <th>Business URL</th>
                <td>{elements.businessURL}</td>
              </tr>
              <tr>
                <th>Business License</th>
                <td>{elements.businessLicense}</td>
              </tr>
              <tr>
                <th>Start Date</th>
                <td>{elements.startDate !== '0000-00-00 00:00:00' ? format(new Date(elements.startDate), 'MM/dd/yyyy') : ''}</td>
              </tr>
              <tr>
                <th>End Date</th>
                <td>{elements.endDate !== '0000-00-00 00:00:00' ? format(new Date(elements.endDate), 'MM/dd/yyyy') : ''}</td>
              </tr>
              <tr>
                <th>ZipCodes</th>
                <td>
                  {elements.ZipCodes.filter(item => item !== "").join(', ')}</td>
              </tr>
              <tr>
                <th>PaymentType</th>
                <td>{elements.PaymentType === 'YearlyBilling' ? 'Annual' : 'Monthly'}</td>
              </tr>
              <tr>
                <th>Approve Status</th>
                <td>
                  {elements.PaymentStatus === 0
                    ? 'Payment Pending'
                    : elements.approveStatus === 0
                      ? 'Approval Pending'
                      : elements.approveStatus === 1
                        ? 'Approved'
                        : elements.approveStatus === 2
                          ? 'Disapproved'
                          : ''}
                </td>
              </tr>
              <tr>
                <th>User Status</th>
                <td>{elements.userStatus === 1 ? 'Enabled' : 'Disabled'}</td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {/* <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button> */}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default MyModal;
